import { Check } from 'lucide-react';
import { passwordChecks } from '../../lib/authValidation';

/** The live checklist under a new-password field: each rule turns purple with a check as it is met. */
export default function PasswordRules({ password, id }) {
  return (
    <ul id={id} className="password-rules" aria-live="polite">
      {passwordChecks(password).map((rule) => (
        <li
          key={rule.id}
          className={
            rule.ok ? 'password-rules__item password-rules__item--ok' : 'password-rules__item'
          }
        >
          <span className="password-rules__mark" aria-hidden="true">
            {rule.ok && <Check size={11} strokeWidth={3} />}
          </span>
          {rule.label}
          <span className="sr-only">{rule.ok ? ' (done)' : ' (needed)'}</span>
        </li>
      ))}
    </ul>
  );
}
